@import '../../vars.css';

.header {
    border-top-left-radius: var(--modal-border-radius);
    border-top-right-radius: var(--modal-border-radius);
}

.size-500 .content,
.size-600 .content {
    padding: var(--modal-s-header-desktop-content-paddings);
    @mixin headline-system_small;
}

.size-800 .content,
.size-1140 .content,
.fullscreen .content {
    padding: var(--modal-l-header-desktop-content-paddings);
    @mixin headline-system_medium;
}

.size-500,
.size-600,
.size-800,
.size-1140,
.fullscreen {
    padding: var(--modal-s-header-paddings);
}

.sticky {
    top: calc(var(--modal-vertical-padding) * -1);

    &.fullscreen {
        top: var(--gap-0);
    }
}
